import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../../models/data-entry-step1'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { ValidAgent } from '../../../models/valid-agent'
import { GoodStandingModel } from '../../../../common/models/good-standing-model'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import * as moment from 'moment'

@Component({
    selector: 'NEJEphoneenrollmentstep1',
    templateUrl: 'phone-enrollment-step1.html'
})
export class NEJEPhoneEnrollmentStep1Component implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    dataEntryStep1 = {} as DataEntryStep1
    isValidAgent: boolean
    disabled: boolean
    isFormValid: boolean
    selFaxContactType: string
    //dateofReceiptInvalid: boolean
    //ContactTypeInvalid: boolean
    showMLPAP: boolean
    public optionrbConactType: ValidatedRadioButtonModel[] = []
    optionrbEnrollmentMethod: ValidatedRadioButtonModel[] = []
    optionrbScope: ValidatedRadioButtonModel[] = []
    selEnrollmentMethod: string
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    agentUserName: string
    hasError: boolean
    EnrollmentMethodError: boolean
    SOAError: boolean
    validAgentModel: ValidAgent
    CUID: string
    AgentID: string
    AdminID: number
    errorMessage: any[]
    IsErrorMesssage: boolean = false
    public loading: boolean = false
    states: State[] = [] as State[]
    mailingstates: State[] = [] as State[]
    planstate: string
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    currentDate: Date

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private _stateGateway: StateGateway
    ) {
        this.optionrbConactType.push({ value: 'Mail', htmlLabel: 'Mail' }, { value: 'Fax', htmlLabel: 'Fax' })
        this.optionrbEnrollmentMethod.push(
            { value: 'Mail', htmlLabel: 'I received a paper application in the mail' },
            { value: 'Paper', htmlLabel: 'I completed a paper application in a face to face meeting with the beneficiary' }
        )
        //this.dateofReceiptInvalid = false
        this.errorMessage = []
        this.GetCurrentDate()
    }

    ngOnInit() {
        let isExternalAgent: boolean = false

        //Remove session object
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()

        if (!this.enrollment.ISBACK) {
            this.enrollment = {} as EnrollmentViewModel
        }
        //this.enrollment = {} as EnrollmentViewModel
        //this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        this.planstate = this.enrollment.APPST
        this.enrollment.FORMNAME = 'NEJEPHONE'
        this.enrollment.ISEXTERNALAGENT = isExternalAgent
        this.dataEntryStep1.DateofReceipt = new Date()
        //this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

        this.isValidAgent = false
        this.hasError = false
        this.ErrorMessages = [] as any[]
        this.EnrollmentMethodError = false

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        if (this._global.currentUser.userProfileName !== undefined && !this._global.currentUser.IsEnoller) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }
        this.dataEntryStep1.AgentName = this.agentUserName
        // this.getState()
    }
    getState(orgId: number): void {
        //this._stateGateway.getAllStates().subscribe(
        //    (states: State[]) => {
        //        states.unshift({ value: 0, text: '-- Choose One --', })
        //        this.mailingstates = states
        //        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0' || this.enrollmentViewModel.MAILST === null) {
        //            this.enrollmentViewModel.MAILST = '0'
        //        }
        //    }
        //)
        if (orgId !== undefined && orgId !== 0) {
            this._enrollementGateway.GetAllParentStatesForOrg(orgId).subscribe((states: ValidatedSelectOptionModel[]) => {
                states.unshift({ value: 0, text: '-- Choose One --' })
                // this.mailingstates = states
                this.states = states
                if (this.planstate === undefined || this.planstate === '' || this.planstate === '0' || this.planstate === null) {
                    this.planstate = '0'
                }
            })
        }
    }

    onChangeAgentID(): void {
        this.errorMessage = []
        this.hasError = false
        this.IsErrorMesssage = false
        this.isValidAgent = !this.isValidAgent
        this.disabled = this.isValidAgent
    }
    onContinue(): void {
        this.errorMessage = []
        this.hasError = false
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false
        this.ErrorMessages = [] as any[]

        if (this._global.currentUser.userProfileName === this.dataEntryStep1.AgentName && sessionStorage.getItem('GoodStandingParams') !== null) {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                var isAgentGoodStanding: boolean = true
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' has not passed training for ' + this._global.selectedPlanYear + '<br/>')
                    this.hasError = true
                    isAgentGoodStanding = false
                }
                if (!this.goodStandingValues.BackgroundCheckStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' background check not approved.<br/>')
                    this.hasError = true
                    isAgentGoodStanding = false
                }
                if (!this._global.currentUser.IsDataEntrySpecialist && !this._global.currentUser.IsDataEntryGroupSpecialist) {
                    if (!this.goodStandingValues.LicenseStatus) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' does not have a valid license.<br/>')
                        isAgentGoodStanding = false
                        this.hasError = true
                    }
                }
                if (!isAgentGoodStanding) {
                    return
                }
            }
        }
        this.loading = true
        this._enrollementGateway.isValidAgent(this.dataEntryStep1.AgentName).subscribe(
            (validAgentModel) => {
                let isagentvalid = true

                if (validAgentModel.errorMessage !== undefined && validAgentModel.errorMessage !== null && validAgentModel.errorMessage.length > 0) {
                    this.ErrorMessages.push(validAgentModel.errorMessage)
                    isagentvalid = false
                } else {
                    if (validAgentModel.agentID === 0) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' Agent not found')
                        isagentvalid = false
                    }
                    if (validAgentModel.showEnrollmentSourceMS === true) {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        //  this.showMLPAP = true
                        this.enrollment.ADMINID = validAgentModel.agentID
                        this.enrollment.AGENTID = String(validAgentModel.agentID)
                        this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                        this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    } else if (validAgentModel.showEnrollmentSource === true) {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        // this.showMLPAP = false
                        this.enrollment.ADMINID = this._global.currentUser.userProfileId
                        this.enrollment.AGENTID = String(validAgentModel.agentID)
                        this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                        this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    }
                }

                this.isValidAgent = isagentvalid
                if (!this.isValidAgent) {
                    this.hasError = true
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                } else {
                    if (this._global.currentUser.isCallCenterRepresentative) {
                        if (validAgentModel.CurrentUser.isCallCenterAdmin) {
                            this.IsErrorMesssage = true
                            this.isValidAgent = false
                            this.errorMessage.push('Your role level cannot submit an Enrollment for an Admin')
                            this.loading = false
                            return
                        } else {
                            this.hasError = false
                            this.IsErrorMesssage = false
                            this.EnrollmentMethodError = false
                            this.SOAError = false
                            this.CUID = validAgentModel.CUID
                            this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                            this.enrollment.AGENTDETAILS = validAgentModel.CurrentUser
                            this.AgentID = String(validAgentModel.agentID)
                            this.getState(this.enrollment.AGENTORGID)
                        }
                    } else {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        this.CUID = validAgentModel.CUID
                        this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                        this.enrollment.AGENTDETAILS = validAgentModel.CurrentUser
                        this.AgentID = String(validAgentModel.agentID)
                        this.getState(this.enrollment.AGENTORGID)
                    }
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    formSubmit(): void {
        this.hasError = false
        this.isFormValid = true
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false
        this.errorMessage = []
        this.enrollment.DEX = 'ICALL'
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (!this.dataEntryStep1.DateofReceipt) {
            //this.dateofReceiptInvalid = true
            this.hasError = false
            this.EnrollmentMethodError = false
            this.IsErrorMesssage = true
            this.errorMessage.push('Date of Receipt cannot be blank')
            this.isFormValid = false
        } else if (this.dataEntryStep1.DateofReceipt) {
            // this.dateofReceiptInvalid = true

            let receiptdate = moment(this.dataEntryStep1.DateofReceipt).toDate()

            if (this.currentDate === undefined && this.currentDate === null) {
                this.currentDate = new Date()
            }

            if (receiptdate > this.currentDate) {
                this.hasError = false
                this.EnrollmentMethodError = false
                this.IsErrorMesssage = true
                this.errorMessage.push('Date of Receipt cannot be future date')
                this.isFormValid = false
            }
        } else {
            this.IsErrorMesssage = false
            //this.dateofReceiptInvalid = false
        }
        if (this.planstate === undefined || this.planstate === null || this.planstate === '' || this.planstate === '0') {
            this.hasError = false
            this.EnrollmentMethodError = false
            this.IsErrorMesssage = true
            this.errorMessage.push('State cannot be blank')
            this.isFormValid = false
        }

        this.enrollment.AGENTDEX = 'ICALL'
        // this.enrollment.DEX = this.dataEntryStep1.DataSource
        this.enrollment.AGENTID = this.AgentID
        this.enrollment.AGENTNAME = this.dataEntryStep1.AgentName
        this.enrollment.APPST = this.planstate
        this.enrollment.USERNAME = this._global.currentUser.userProfileName
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== null) {
            this.enrollment.PLANYEAR = String(this._global.selectedPlanYear)
        }
        //  this.enrollment.INSURANCECOMPID = this._global.currentUser.
        this.enrollment.CUID = this.CUID
        this.enrollment.DATEOFRECEIPT = this.dataEntryStep1.DateofReceipt
        if (this.isFormValid) {
            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            this.loading = false
            this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step2'])
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    GetCurrentDate() {
        this._enrollementGateway.getCurrentDate().subscribe((date: Date) => {
            if (date !== undefined && date !== null) this.currentDate = moment(date).toDate()
            else this.currentDate = new Date()
        })
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
}
